export default function MyBills() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              My Bills
            </div>
            <div className="page-sub" id="page-sub">
              View and pay your bills
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div
            style={{
              background: "linear-gradient(135deg,#633806,#BA7517)",
              borderRadius: "var(--radius-md)",
              padding: "14px 20px",
              marginBottom: 16,
              display: "flex",
              alignItems: "center",
              gap: 14,
            }}
          >
            <span style={{ fontSize: 20 }}>🪙</span>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 10,
                  color: "rgba(255,255,255,0.7)",
                  textTransform: "uppercase",
                  letterSpacing: ".07em",
                }}
              >
                Coin Balance
              </div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#fff" }}>
                850
              </div>
            </div>
            <button
              onclick="openAddCoinModal('tenant')"
              style={{
                background: "rgba(255,255,255,0.2)",
                border: "1px solid rgba(255,255,255,0.35)",
                color: "#fff",
                borderRadius: "var(--radius-md)",
                padding: "6px 14px",
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              + Add Coins
            </button>
          </div>
          <div className="card mb16">
            <div className="flex-between mb10">
              <div>
                <div className="card-title" style={{ margin: 0 }}>
                  ⚡ Electricity Meter Reading
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  Submit your meter reading each month for bill generation
                </div>
              </div>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 12,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                  padding: "12px 14px",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginBottom: 4,
                  }}
                >
                  Last Approved Reading
                </div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 800,
                    color: "var(--teal)",
                  }}
                >
                  1020 units
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginTop: 2,
                  }}
                >
                  Mar 2025
                </div>
              </div>
              <div
                style={{
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                  padding: "12px 14px",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginBottom: 4,
                  }}
                >
                  This Month Status
                </div>
                <div
                  style={{ fontSize: 13, fontWeight: 700, color: "#92400E" }}
                >
                  ⏳ Submitted — Awaiting Approval
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginTop: 2,
                  }}
                >
                  Reading: 1147 units · Apr 30, 2025
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: 12,
                color: "#92400E",
                background: "#FEF3C7",
                borderRadius: 8,
                padding: "10px 12px",
              }}
            >
              ⏳ Your reading for <strong>Apr 2025</strong> is under review.
              Bill will be generated once approved.
            </div>
          </div>
          <div className="card">
            <div className="card-title">Monthly Bills</div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f9fafb" }}>
                    <th
                      style={{
                        padding: 10,
                        textAlign: "left",
                        fontSize: 11,
                        color: "#6b7280",
                      }}
                    >
                      Description
                    </th>
                    <th
                      style={{
                        padding: 10,
                        textAlign: "left",
                        fontSize: 11,
                        color: "#6b7280",
                      }}
                    >
                      Details
                    </th>
                    <th
                      style={{
                        padding: 10,
                        textAlign: "left",
                        fontSize: 11,
                        color: "#6b7280",
                      }}
                    >
                      Amount
                    </th>
                    <th
                      style={{
                        padding: 10,
                        textAlign: "left",
                        fontSize: 11,
                        color: "#6b7280",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td
                      colSpan={4}
                      style={{
                        padding: "8px 10px",
                        background: "#f8fafc",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-secondary)",
                      }}
                    >
                      📅 Mar 2025
                    </td>
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>
                      🏠 Base Rent
                    </td>
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>—</td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      ₹8,500
                    </td>
                    <td style={{ padding: "8px 10px" }}>
                      <span className="badge badge-active">✓ Paid</span>
                    </td>
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>
                      ⚡ Electricity
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 11,
                        color: "var(--text-secondary)",
                      }}
                    >
                      120 units × ₹8.5
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      ₹1,020
                    </td>
                    <td />
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>
                      💧 Water Charges
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 11,
                        color: "var(--text-secondary)",
                      }}
                    >
                      Fixed
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      ₹200
                    </td>
                    <td />
                  </tr>
                  <tr style={{ background: "#f0fdf4" }}>
                    <td
                      style={{ padding: 10, fontWeight: 700, fontSize: 13 }}
                      colSpan={2}
                    >
                      Total Due
                    </td>
                    <td
                      style={{
                        padding: 10,
                        fontWeight: 800,
                        fontSize: 14,
                        color: "var(--blue)",
                      }}
                    >
                      ₹9,720
                    </td>
                    <td style={{ padding: 10 }} />
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td
                      colSpan={4}
                      style={{
                        padding: "8px 10px",
                        background: "#f8fafc",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-secondary)",
                      }}
                    >
                      📅 Apr 2025
                    </td>
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>
                      🏠 Base Rent
                    </td>
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>—</td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      ₹8,500
                    </td>
                    <td style={{ padding: "8px 10px" }}>
                      <span className="badge badge-gray">Awaiting Reading</span>
                    </td>
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>
                      💧 Water Charges
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 11,
                        color: "var(--text-secondary)",
                      }}
                    >
                      Fixed
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      ₹200
                    </td>
                    <td />
                  </tr>
                  <tr
                    style={{ borderBottom: "0.5px solid var(--border-light)" }}
                  >
                    <td style={{ padding: "8px 10px", fontSize: 12 }}>
                      📌 Maintenance
                    </td>
                    <td />
                    <td
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      ₹500
                    </td>
                    <td />
                  </tr>
                  <tr style={{ background: "#f0fdf4" }}>
                    <td
                      style={{ padding: 10, fontWeight: 700, fontSize: 13 }}
                      colSpan={2}
                    >
                      Total Due
                    </td>
                    <td
                      style={{
                        padding: 10,
                        fontWeight: 800,
                        fontSize: 14,
                        color: "var(--blue)",
                      }}
                    >
                      ₹9,200
                    </td>
                    <td style={{ padding: 10 }} />
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
